"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var AudioRecorderStore = /*#__PURE__*/function () {
  function AudioRecorderStore(stream, onHandleData) {
    (0, _classCallCheck2["default"])(this, AudioRecorderStore);
    this.recorder = new MediaRecorder(stream);
    this.recorder.ondataavailable = onHandleData;
  }
  return (0, _createClass2["default"])(AudioRecorderStore, [{
    key: "createBlob",
    value: function createBlob(data) {
      return new Blob(data, {
        type: 'audio/ogg; codecs=opus'
      });
    }
  }, {
    key: "record",
    value: function record() {
      if (this.recorder.state !== 'recording') {
        this.recorder.start();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this = this;
      return new Promise(function (resolve) {
        if (_this.recorder.state === 'inactive') {
          resolve();
          return;
        }
        _this.recorder.onstop = resolve;
        _this.recorder.stop();
      });
    }
  }]);
}();
var _default = exports["default"] = AudioRecorderStore;